import { CustomErrorPage } from '~/components/common/CustomErrorPage'
import { NextPageContext } from 'next'
import ErrorPage from 'next/error'

import { IS_PRODUCTION } from '~/lib/config'

const errorTitle = 'エラーが発生しました'

const errorDetail = [
  '大変申し訳ございません。想定していないエラーが発生しました。',
  'お手数をおかけしますが、toridori marketingのホームに戻っていただきますようお願いいたします。',
]

const Error = ({ error, info }: { error: Error; info: React.ErrorInfo }) => {
  return (
    <CustomErrorPage
      errorTitle={errorTitle}
      errorDetail={errorDetail}
      forDev={!IS_PRODUCTION ? { error, info } : undefined}
    />
  )
}

Error.getInitialProps = (ctx: NextPageContext) => {
  return ErrorPage.getInitialProps(ctx)
}

export default Error
